import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClientProvider } from '@tanstack/react-query'
import { queryClient } from './lib/queryClient.js'
import App from './App.jsx'
import { AuthProvider } from './contexts/AuthContext.jsx'
import { GroupsProvider } from './contexts/GroupsContext.jsx'
import { PlatformProvider } from './contexts/PlatformContext.jsx'
import { CexProvider } from './contexts/CexContext.jsx'
import { CexToastProvider } from './contexts/CexToastContext.jsx'
import { PlatformConnectionToasts } from './components/PlatformConnectionToasts.jsx'
import { ThemeProvider, bootstrapLotosTheme } from './contexts/ThemeContext.jsx'
import { cexRumUrl, dexRumUrl } from './lib/apiBase.js'
import './styles/index.css'

bootstrapLotosTheme()

function _rumBody(metric) {
  return JSON.stringify({
    name: metric.name,
    value: metric.value,
    id: metric.id,
    rating: metric.rating,
    delta: metric.delta,
    navigationType: metric.navigationType,
  })
}

function sendRumToUrl(url, metric) {
  const body = _rumBody(metric)
  try {
    if (typeof navigator !== 'undefined' && navigator.sendBeacon && typeof Blob !== 'undefined') {
      const blob = new Blob([body], { type: 'application/json' })
      if (navigator.sendBeacon(url, blob)) return
    }
  } catch {
    /* fall through to fetch */
  }
  fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body,
    keepalive: true,
    credentials: 'include',
  }).catch(() => {})
}

function sendRum(metric) {
  const dexU = dexRumUrl()
  sendRumToUrl(dexU, metric)
  try {
    const cexU = cexRumUrl()
    if (cexU && cexU !== dexU) sendRumToUrl(cexU, metric)
  } catch {
    /* CEX RUM is optional */
  }
}

if (import.meta.env.PROD) {
  import('web-vitals').then(({ onLCP, onCLS, onINP, onFCP, onTTFB }) => {
    onLCP(sendRum)
    onCLS(sendRum)
    onINP(sendRum)
    onFCP(sendRum)
    onTTFB(sendRum)
  })
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter future={{ v7_startTransition: true }}>
        <ThemeProvider>
          <AuthProvider>
            <PlatformProvider>
              <CexProvider>
                <CexToastProvider>
                  <PlatformConnectionToasts />
                  <GroupsProvider>
                    <App />
                  </GroupsProvider>
                </CexToastProvider>
              </CexProvider>
            </PlatformProvider>
          </AuthProvider>
        </ThemeProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
)
